import React from 'react';
import { TitleContainer } from '../TitleContainer';
import { GeoContainer } from '../GeoContainer';
import { PriceContainer } from '../PriceContainer';
import { DescriptionContainer } from '../DescriptionContainer';
import { SimilarLinkContainer } from '../SimilarLinkContainer';
import { MortgageAdFoxBannerContainer } from '../MortgageAdFoxBannerContainer';
import { IdenticalOffersLinkContainer } from '../IdenticalOffersLinkContainer';
import { AuctionTitleContainer } from '../AuctionTitleContainer';

export function OfferGeneralInfoContainer() {
  const updateCb = React.useRef(() => {});

  // после загрузки банера пересчитываем количество доступных строк описания
  const handleAdFoxLoaded = React.useCallback(() => {
    updateCb.current();
  }, []);

  const handleSetUpdateCb = React.useCallback((cb: () => void) => {
    updateCb.current = cb;
  }, []);

  return (
    <>
      <TitleContainer />
      <GeoContainer />
      <AuctionTitleContainer />
      <PriceContainer>
        <MortgageAdFoxBannerContainer onLoad={handleAdFoxLoaded} />
      </PriceContainer>
      <DescriptionContainer setCallback={handleSetUpdateCb} />
      <SimilarLinkContainer />
      <IdenticalOffersLinkContainer />
    </>
  );
}
